import { Observable } from 'rxjs';

import { Subject } from 'rxjs';
import { IntralinksFile, IntralinksMapping } from '../../tamalelibs/models/intralinks.model';

export class IntralinksGroupConfig {
    name: string;
    id: string;
    workspaceId: string;
    actionSubject$: Subject<IntralinksGroupAction>;
    feedbackSubject$: Subject<IntralinksGroupReadyFeedback>;
    showWorkspaceName = false;
}

export enum IntralinksGroupActionType {
    RELOAD = 'RELOAD',
    UPDATE = 'UPDATE'
}

export enum IntralinksGroupFeedbackType {
    READY = 'READY',
    LOADED = 'LOADED'
}

export interface IntralinksGroupAction {
    type: IntralinksGroupActionType;
    payload: any;
}

export class IntralinksGroupReloadAction implements IntralinksGroupAction {
    type: IntralinksGroupActionType = IntralinksGroupActionType.RELOAD;
    payload: (id: string, workspaceId: string) => Observable<IntralinksFile[]>;
}


export class IntralinksGroupUpdateAction implements IntralinksGroupAction {
    type: IntralinksGroupActionType = IntralinksGroupActionType.UPDATE;
    payload: IntralinksFile;
}

export class IntralinksGroupReadyFeedback {
    type: IntralinksGroupFeedbackType = IntralinksGroupFeedbackType.READY;
    payload: any;
}

export class IntralinksGroupLoadedFeedback {
    type: IntralinksGroupFeedbackType = IntralinksGroupFeedbackType.LOADED;
    payload: any;
}

export class IntralinksGroupContainerConfig {
    constructor() {
        this.actionSubject$ = new Subject<IntralinksGroupContainerAction>();
        this.feedbackSubject$ = new Subject<IntralinksGroupContainerReadyFeedback>();
    }
    folders: any[];
    mappings?: IntralinksMapping;
    actionSubject$: Subject<IntralinksGroupContainerAction>;
    feedbackSubject$: Subject<IntralinksGroupContainerReadyFeedback>;
    showWorkspaceName = false;
}

export class IntralinksGroupContainerParams {
    timeValue: string;
    timeUnit: string;
    keyword: string;
    workspaceId: string;
    screenId: string;
}

export enum IntralinksGroupContainerActionType {
    RELOAD = 'RELOAD',
    UPDATE_FILE = 'UPDATE_FILE'
}

export enum IntralinksGroupContainerFeedbackType {
    READY = 'READY'
}

export interface IntralinksGroupContainerAction {
    type: IntralinksGroupContainerActionType;
    payload: any;
}

export class IntralinksGroupContainerReloadAction implements IntralinksGroupContainerAction {
    type: IntralinksGroupContainerActionType = IntralinksGroupContainerActionType.RELOAD;
    payload: IntralinksGroupContainerParams;
}

export class IntralinksGroupContainerUpdateFileAction implements IntralinksGroupContainerAction {
    type: IntralinksGroupContainerActionType = IntralinksGroupContainerActionType.UPDATE_FILE;
    payload: IntralinksFile;
}

export class IntralinksGroupContainerReadyFeedback {
    type: IntralinksGroupContainerFeedbackType = IntralinksGroupContainerFeedbackType.READY;
    payload: any;
}
